import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import PriceDisplay from './components/PriceDisplay';
import AboutPage from './components/AboutPage';
import SetPasswordPage from './components/SetPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import VerifyPage from './components/VerifyPage';
import InfoCenter from './components/InfoCenter';
import PrivacyPolicy from './components/PrivacyPolicy';
import StorePage from './components/StorePage';
import ShopPage from './components/ShopPage';
import BitWheelPage from './components/BitWheelPage';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';


const App = () => {
  return (
    <AuthProvider>
      <GoogleOAuthProvider clientId={"726694494962-bdh2mr4th3h1pscpo9eho50bmbro4r43.apps.googleusercontent.com"}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PriceDisplay />} />
            {/* Main AboutPage route */}
            <Route path="/about" element={<AboutPage />} />
            {/* New route with category parameter */}
            <Route path="/about/:category" element={<AboutPage />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/info-center" element={<InfoCenter />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/store" element={<StorePage />} />
            <Route path="/info-center/:articleSlug" element={<InfoCenter />} />
            <Route path="/bit-wheel" element={<BitWheelPage />} />
            <Route path="/bitwheel" element={<BitWheelPage />} />
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminPanel />} />
            <Route path="*" element={<PriceDisplay />} />
          </Routes>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </AuthProvider>
  );
};

export default App;
